import { __decorate } from "tslib";
import React, { Component } from 'react';
import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import sortBy from 'lodash/sortBy';
import { action, toJS } from 'mobx';
import { observer } from 'mobx-react';
import { getProPrefixCls } from 'choerodon-ui/lib/configure/utils';
import Tag from 'choerodon-ui/lib/tag';
import Animate from '../animate';
import Icon from '../icon';
import { $l } from '../locale-context';
export const TIMESTAMP = '__TIMESTAMP__';
export var SelectionsPosition;
(function (SelectionsPosition) {
    SelectionsPosition["side"] = "side";
    SelectionsPosition["below"] = "below";
})(SelectionsPosition || (SelectionsPosition = {}));
let SelectionList = class SelectionList extends Component {
    constructor() {
        super(...arguments);
        this.prefixCls = getProPrefixCls('modal');
        this.unSelect = (record) => {
            const { dataSet, treeFlag } = this.props;
            record.setState(TIMESTAMP, 0);
            if (treeFlag === 'Y') {
                dataSet.treeUnSelect(record);
            }
            else {
                dataSet.unSelect(record);
            }
            if (!isUndefined(record.parent)) {
                dataSet.unSelect(record.parent);
            }
        };
        this.renderBelow = () => {
            const { dataSet, treeFlag, valueField = '', textField = '' } = this.props;
            const records = treeFlag === 'Y' ? dataSet.treeSelected : dataSet.selected;
            if (isEmpty(records)) {
                return null;
            }
            const classString = `${this.prefixCls}-selection-list-below`;
            const animateChildren = this.getRecords(records).map((record) => {
                return (React.createElement("li", { key: record.get(valueField), className: `${classString}-item` },
                    React.createElement(Tag, { closable: true, onClose: () => { this.unSelect(record); } },
                        React.createElement("span", null, record.get(textField)))));
            });
            return (React.createElement("div", { className: classString },
                React.createElement("p", { className: `${classString}-intro` }, $l('Lov', 'selection_tips', {
                    count: React.createElement("b", { key: "count" }, records.length),
                })),
                React.createElement(Animate, { className: `${classString}-list`, transitionAppear: true, transitionName: "fade", component: "ul" }, animateChildren)));
        };
    }
    getRecords(records) {
        return sortBy(records, function (item) {
            return item.getState(TIMESTAMP) ?? -1;
        });
    }
    renderSide() {
        const { dataSet, treeFlag, valueField = '', textField = '', selectionProps = {} } = this.props;
        const { nodeRenderer, placeholder } = selectionProps;
        const records = treeFlag === 'Y' ? dataSet.treeSelected : dataSet.selected;
        const isEmptyList = isEmpty(records);
        if (isEmptyList && !placeholder) {
            return null;
        }
        const classString = `${this.prefixCls}-selection-list`;
        const animateChildren = this.getRecords(records).map((record) => {
            return (React.createElement("li", { key: record.get(valueField), className: `${classString}-item` },
                nodeRenderer ? toJS(nodeRenderer(record)) : React.createElement("span", null, record.get(textField)),
                React.createElement(Icon, { type: "cancel", onClick: () => {
                        this.unSelect(record);
                    } })));
        });
        return (React.createElement("div", { className: `${classString}-container` },
            React.createElement("p", { className: `${classString}-intro` }, isEmptyList ? placeholder : $l('Lov', 'selection_tips', {
                count: React.createElement("b", { key: "count" }, records.length),
            })),
            React.createElement(Animate, { className: `${classString}-list`, transitionAppear: true, transitionName: "slide-right", component: "ul" }, animateChildren)));
    }
    render() {
        const { selectionsPosition } = this.props;
        if (selectionsPosition === SelectionsPosition.side) {
            return this.renderSide();
        }
        if (selectionsPosition === SelectionsPosition.below) {
            return this.renderBelow();
        }
        return null;
    }
};
__decorate([
    action
], SelectionList.prototype, "unSelect", void 0);
SelectionList = __decorate([
    observer
], SelectionList);
export default SelectionList;
